import React, {useEffect, useState} from 'react';
import hoistoryStore from "../../store/historyStore";
import * as util from "../../utils/util";
import api from "../../utils/api";

import {useLocation, useNavigate} from 'react-router-dom';

import {Accordion, AccordionDetails, AccordionSummary, Box, Grid, List, ListItem, Typography} from "@mui/material";
import Top from "../Top";
import HistoryLoadState from "../../components/HistoryLoadState";
import Bottom from "../Bottom";
import Circle from "../../components/CircleProgress";
import BarChart from "../../components/BarChart";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import calendarfood from "../../assets/icon/calendarfood.gif";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import {styled} from "@mui/material/styles";

const params = {
  token: '',
  from: '',
  to: '',
  target: ''
}

const initTargetCalory = {
  calory: 0,
  target_calory: 0
}

const HistoryEatFood = () => {
  const navigate = useNavigate();
  const {state} = useLocation();
  const {targetDayValue} = state ?? {};

  const storeData: any = hoistoryStore();
  const [targetCalory, setTargetCalory] = React.useState(initTargetCalory);
  const [targetMeal, setTargetMeal] = React.useState(
    {
      morning_names: '', morning_calory: '', lunch_names: '', lunch_calory: '',
      dinner_names: '', dinner_calory: '', snack_names: '', snack_calory: ''
    });
  const [series, setSeries] = React.useState([
    { dataKey: 'morning', label: '아침', valueFormatter: (value: number | null) => `${value}mm`, stack: 'total' }
    , { dataKey: 'lunch', label: '점심', valueFormatter: (value: number | null) => `${value}mm`, stack: 'total' }
    , { dataKey: 'dinner', label: '저녁', valueFormatter: (value: number | null) => `${value}mm`, stack: 'total' }
    , { dataKey: 'snack', label: '간식', valueFormatter: (value: number | null) => `${value}mm`, stack: 'total' }
  ]);
  const [dataset, setDataset] = React.useState([{ morning: 0, lunch: 0, dinner: 0, snack: 0, month: '' }]);
  const [dayValue, setDayValue] = useState(targetDayValue ?? 0);
  /**
   * 화면 상단 날짜. 서버 응답이 아니라 dayValue 에서 바로 만든다.
   *
   * 예전에는 빈 문자열로 시작해 조회 성공(result_code === '0') 안에서만 채웠다.
   * 그래서 (1) 응답이 올 때까지 '..' 만 보였고 (2) 조회가 실패하면 영영 '..' 로 남았다.
   * 날짜는 클라이언트가 이미 아는 값이라 서버 응답에 묶어 둘 이유가 없다.
   */
  const targetDate = util.getDateByCustom('yyyyMMdd', dayValue);
  const [loading, setLoading] = React.useState(true);
  const [failed, setFailed] = React.useState(false);
  const [reloadNonce, setReloadNonce] = React.useState(0);

  useEffect(() => {
    setCaloryData();
  }, [dayValue, reloadNonce]);

  function setCaloryData() {
    setLoading(true);
    setFailed(false);
    // 섭취 칼로리 정보 조회
    params.token = localStorage.getItem('token') || '';
    params.from = util.getDateByCustom('yyyyMMdd', dayValue - 7);
    params.to = util.getDateByCustom('yyyyMMdd', dayValue);
    params.target = util.getDateByCustom('yyyyMMdd', dayValue);

    api.get(`app/api/v1/AP_002_002?token=${params.token}&from=${params.from}&to=${params.to}&target=${params.target}`).then(res => {
      if (res.data.result_code === '0') {
        setTargetCalory(res.data.result_data.target);
        setTargetMeal(res.data.result_data.target.meal);
        setSeries(series);
        const tempArr = getCaloryDataset(res.data.result_data.data);
        setDataset(tempArr.reverse());
        const morningList = res.data.result_data.target.meal.morning.map((v: any) => true ? { ...v, gubun: 'morning', calory: Number(v.calory) / Number(v.amount), amount: Number(v.amount) } : v);
        const lunchList = res.data.result_data.target.meal.lunch.map((v: any) => true ? { ...v, gubun: 'lunch', calory: Number(v.calory) / Number(v.amount), amount: Number(v.amount) } : v);
        const dinnerList = res.data.result_data.target.meal.dinner.map((v: any) => true ? { ...v, gubun: 'dinner', calory: Number(v.calory) / Number(v.amount), amount: Number(v.amount) } : v);
        const snackList = res.data.result_data.target.meal.snack.map((v: any) => true ? { ...v, gubun: 'snack', calory: Number(v.calory) / Number(v.amount), amount: Number(v.amount) } : v);
        storeData.setSelectedFoodList(morningList.concat(lunchList).concat(dinnerList).concat(snackList));
      } else {
        // result_code 가 '0' 이 아니면 조회 실패다. 예전에는 아무 처리도 없어서
        // 수치는 0 인 채로, 날짜는 '..' 로 굳고 사용자에게는 아무 안내도 없었다.
        // (실측 2026-08-18: AP_002_002 가 이 계정에 1002 를 반환한다)
        console.warn('[기록] 조회 실패 result_code=', res.data.result_code, res.data.result_message);
        setFailed(true);
      }
    }).catch(function (error) {
      console.log(error);
      setFailed(true);
    }).finally(function () {
      setLoading(false);
    });
  }

  // 섭취 칼로리 바차트 데이터 설정
  function getCaloryDataset(resData: any) {
    let tempArr = [];
    const series = ['morning', 'lunch', 'dinner', 'snack'];
    const monthArr = resData.morning_v2.map((item: any) => item.x);
    let index = 0;

    for (let sr of series) {
      for (let item of resData[sr + '_v2']) {
        index++;
        let obj = { morning: 0, lunch: 0, dinner: 0, snack: 0, month: monthArr[index] };
        if (sr === 'morning') {
          obj.month = item.x;
          // @ts-ignore
          obj[sr] = item.y;
          tempArr.push(obj)
        } else {
          // @ts-ignore
          tempArr.find((v: any) => v.month === item.x)[sr] = item.y;
        }
      }
    }
    return tempArr;
  }



  return (
    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 12, pl: 2, pr: 2, boxSizing: 'border-box' }} spacing={6}>
      <Top title="식사 기록" />

      <Grid sx={{ bgcolor: '#F1F2F4', p: 0, width: '100%', minHeight: 500 }}>
        <Box>
          <Typography component="div" sx={{ fontSize: 20, color: '#555', m: 4, mb: 0, textAlign: 'center', fontWeight: 700 }}>
            <ArrowLeftIcon onClick={() => setDayValue((prev: any) => prev - 1)} sx={{ verticalAlign: 'text-bottom' }} />
            {targetDate.slice(0, 4) + '.' + targetDate.slice(4, 6) + '.' + targetDate.slice(6, 8)}
            <ArrowRightIcon onClick={() => setDayValue((prev: any) => prev + 1)} sx={{ 'display': dayValue < 0 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
          </Typography>

          {/* 조회 중 / 실패 표시 — 날짜 바로 아래 한 줄 */}
          <HistoryLoadState loading={loading} failed={failed} onRetry={() => setReloadNonce((n) => n + 1)} />

          <Stack direction={'row'} justifyContent={'center'} sx={{ m: '20px 0', p: 1, bgcolor: '#fff', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Grid sx={{
              '& .CircleChart .MuiGauge-root': { width: '130px', height: '130px' },
              '& .CircleChart .circleText': { fontSize: 24, },
            }}>
              <Circle progress={{ goal: targetCalory.target_calory, value: targetCalory.calory }} />
            </Grid>

            <Stack justifyContent={'center'} sx={{ m: 'auto', }}>
              <Avatar alt="" src={calendarfood} sx={{ m: 'auto', width: '60px', height: '60px' }} />
            </Stack>

            <Stack direction={'row'} alignItems={'center'} sx={{ ml: 'auto', mr: 2 }}>
              <Stack direction={'column'} sx={{ ml: 'auto' }}>
                <Typography component="div" sx={{ fontSize: 35, color: '#EF8322', fontWeight: 700 }}>
                  {util.formatComma(Math.round(targetCalory.calory))}
                </Typography>
                <Typography component="span" sx={{ fontSize: 20, color: '#999', mb: 0, textAlign: 'right' }}>
                  {util.formatComma(targetCalory.target_calory)}
                </Typography>
              </Stack>

              <Typography component="div" sx={{ fontSize: 18, color: '#777', ml: 1, mb: 2 }}>
                kcal
              </Typography>
            </Stack>
          </Stack>

          <Accordion defaultExpanded sx={{ borderRadius: '15px', position: 'static' }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{
                '&#panel1a-header': { minHeight: '55px' },
                '& .MuiAccordionSummary-content.Mui-expanded': { m: 0 }
              }}
            >
              <Typography sx={{ fontSize: 16, color: '#555', fontWeight: 700 }}>식사 기록</Typography>
            </AccordionSummary>
            <Divider />
            <AccordionDetails>
              <List sx={{ p: 0 }}>

                <ListItem>
                  <Grid container alignItems="center">
                    <Grid item xs={8}>
                      <Typography component="div" sx={{ fontSize: 16, color: '#555', fontWeight: 700 }}>아침</Typography>
                      <Typography component="div" sx={{ fontSize: 14, color: '#777', }}>{targetMeal.morning_names}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'right', mr: 1 }}>{util.formatComma(targetMeal.morning_calory)}</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography component="div" sx={{ fontSize: 14, color: '#999', }}>Kcal</Typography>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
                <ListItem>
                  <Grid container alignItems="center">
                    <Grid item xs={8}>
                      <Typography component="div" sx={{ fontSize: 16, color: '#555', fontWeight: 700 }}>점심</Typography>
                      <Typography component="div" sx={{ fontSize: 14, color: '#777', }}>{targetMeal.lunch_names}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'right', mr: 1 }}>{util.formatComma(targetMeal.lunch_calory)}</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography component="div" sx={{ fontSize: 14, color: '#999', }}>Kcal</Typography>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
                <ListItem>
                  <Grid container alignItems="center">
                    <Grid item xs={8}>
                      <Typography component="div" sx={{ fontSize: 16, color: '#555', fontWeight: 700 }}>저녁</Typography>
                      <Typography component="div" sx={{ fontSize: 14, color: '#777', }}>{targetMeal.dinner_names}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'right', mr: 1 }}>{util.formatComma(targetMeal.dinner_calory)}</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography component="div" sx={{ fontSize: 14, color: '#999', }}>Kcal</Typography>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
                <ListItem>
                  <Grid container alignItems="center">
                    <Grid item xs={8}>
                      <Typography component="div" sx={{ fontSize: 16, color: '#555', fontWeight: 700 }}>간식</Typography>
                      <Typography component="div" sx={{ fontSize: 14, color: '#777', }}>{targetMeal.snack_names}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'right', mr: 1 }}>{util.formatComma(targetMeal.snack_calory)}</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography component="div" sx={{ fontSize: 14, color: '#999', }}>Kcal</Typography>
                    </Grid>
                  </Grid>
                </ListItem>
              </List>
            </AccordionDetails>
          </Accordion>

          <Grid container justifyContent="center" alignItems="center" >
             <Stack sx={editbtn} >
               <EditButton onClick={() => navigate('/history/HistoryFoodInput', {state: {targetDate: targetDate, targetDayValue: dayValue}})}>입력 하기</EditButton>
            </Stack>
          </Grid>

          <Box sx={{ bgcolor: '#fff', p: '0 10px 20px 10px', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ p: 1 }}>
              <Stack >
                <Typography component="div" sx={{ fontSize: 14, color: '#555', }}>최근 7일</Typography>
              </Stack>
              <Stack sx={{ ml: 'auto', zIndex: 2 }} >
                <Button sx={{ fontSize: 12, color: '#555', }} endIcon={<ArrowRightIcon />} 
                  onClick={() => { navigate('../history/MonthHistory', {state: {type: 'meal'}}) }}>
                  월간현황
                </Button>
              </Stack>
            </Stack>
            <Divider />

            <Box sx={{ mt: -3.5 }}>
              <BarChart dataset={dataset}
                chartSetting={chartSet}
                series={series}
              />
            </Box>
          </Box>
        </Box>
      </Grid>

      <Bottom />
    </Stack>
  );
}

const chartSet = {
  xAxis: [
    {
      label: '',
    },

  ],
  maxWidth: 450,
  height: 300,
  slotProps: {
    legend: {
      direction: 'row',
      position: { vertical: 'bottom', horizontal: 'middle' },
      padding: -5,
      itemMarkWidth: 10,
      itemMarkHeight: 10,
      labelStyle: {
        fontSize: 12,
      },
    },
  },
};

const editbtn = {
  width:'49%',
  alignItems: 'center'
}

const EditButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight:700,
  padding: '6px 20px',
  lineHeight: 1.5,
  backgroundColor: '#fff',
  border:'1px solid #EF8322',
  borderRadius:'20px',
  color:'#EF8322',
  margin:'10px 0 30px 0',
  width:'90%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color:'#fff'
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

export default HistoryEatFood;